/**
 * The S3 object key a deliverable `link` points at.
 *
 * Links arrive from the API as full virtual-hosted S3 URLs whose path is
 * already percent-encoded, and `URL.pathname` hands that path back still
 * encoded — so the raw pathname is not a usable key. Passing it to the AWS SDK
 * encodes it a second time (the SDK escapes every `Key` itself), turning
 * `reports (1).tar.gz` into a request for `reports%2520%281%29.tar.gz` and a
 * 404. Decoding here leaves the SDK's own escaping as the only encoding
 * applied.
 *
 * Falls back to the raw value when `link` is already a plain key, and to the
 * undecoded path when a segment isn't valid percent-encoding (a filename with
 * a stray `%`) — a download button needs a key back, not a `URIError`.
 */
export function s3KeyFromLink(link: string | null | undefined): string {
  if (!link) {
    return '';
  }

  let path;
  try {
    path = new URL(link).pathname.slice(1);
  } catch {
    return link;
  }

  try {
    return path.split('/').map(decodeURIComponent).join('/');
  } catch {
    return path;
  }
}
